import React from 'react'
import { NavLink } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav'

const NAV_ITEMS = [
  { to: 'items', label: 'All Items', end: false },
  { to: 'categories', label: 'Categories', end: true },
  { to: 'modifiers', label: 'Modifiers', end: true },
  { to: 'locations', label: 'Locations', end: true },
  { to: 'orders', label: 'Live Orders', end: true },
  { to: 'import-export', label: 'Import / Export', end: true },
  { to: '/fnb-eod-report', label: 'End of Day Report', end: true },
]

export default function MarketplaceSubnav() {
  return (
    <div className="d-flex mb-4">
      <Nav
        as="ul"
        variant="pills"
        className="w-max-content nav-pills-default"
        aria-label="Marketplace sections"
      >
        {NAV_ITEMS.map(({ to, label, end }) => (
          <Nav.Item as="li" key={to}>
            <Nav.Link as={NavLink} to={to} end={end} className="text-nowrap">
              {label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  )
}
